// @flow
import generalIcons from '~/core/constants/icons/general-svg';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const CookieContainer = styled.div`
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 999999;
`;

export const InfoIcon = styled(SVGIcon).attrs({ type: generalIcons.INFO })`
    height: 0.75em;
    margin-left: 0.25em;
    position: relative;
    top: 0.1em;
    width: 0.75em;

    & g {
        fill: ${props => props.theme.primaryFontColor};
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/cookie-policy/styles.js